import React from 'react';

import { LazySecurityConfigurationPage } from '@confluence/site-settings/entry-points/SecurityConfigurationPage';
import { ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/securityConfigurationConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminSecurityConfigurationRoute = () => <LazySecurityConfigurationPage />;

AdminSecurityConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
